import { isStatusCodeError } from './isStatusCodeError.ts';

/**
 * This is named for the HTTP status message and checks specifically for a 401.
 * It is different from the method in next/packages/unauthorized-error-boundary/src/UnauthorizedErrorBoundary.tsx,
 * which checks for a 403 and an authorized key.
 */
export const isUnauthorizedError = (error: Parameters<typeof isStatusCodeError>[0]): boolean =>
	isStatusCodeError(error, '401');
